<div class="container">
	<div class="row">
		<div class="col-12" style="text-align: center; margin-top: 10px;">
			<p class="dep1">MIZORAM CSC-VLE ASSOCIATION</p>
			<img src="./assets/img/logo.jpg" alt="Jane" style="width:200px;">		
			<p class="dep2">Official Nomination for Office Bearer 2020-21</p>
		</div>
	</div>
	<div class="row">
		<div class="col-md-9">
			<div class="row" style="text-align:center">
			  <div class="col-md-4" *ngFor="let d of noData">
			    <div class="card">
			      <img src="{{d.image}}" style="width:100%">
			      <div class="cont">
			        <p class="title">{{d.fullName}} ({{d.Age}})</p>
			        <p class="subtitle">Location:  {{d.location}}</p>
			      </div>
			    </div>
			  </div>				
			</div>
		</div>
		<div class="col-md-3">
			<div class="card">
				<div class="card-header">Registered Voter</div>
				<div class="card-body"><button class="btn btn-block btn-primary" (click)="login()">
					Cast Vote
				</button> </div>
			</div>

			<div class="card">
				<div class="card-header">Not yet register?</div>
				<div class="card-body"><button class="btn btn-block btn-success" [disabled]="disableRegister" (click)="register()">Register now</button></div>
			</div>

			<div class="card">
				<div class="card-header">Notice</div>
				<div class="card-body" style="padding: 0px;">
					<ul>
						<li>
							Voter Registration will end on 13-Dec-2020 Midnight
						</li>
						<li>
							Voting will commence from 14-Dec-2020 and end at 16-Dec-2020 NOON
						</li>
					</ul> 
				</div>
			</div>
		</div>
	</div>
</div>
